import { ActionRegistry } from '@packages/table-builder';

const domainModules = import.meta.glob<Record<string, unknown>>(
  './*/*.actions.ts'
);

/**
 * Auto-registers all domain loaders by scanning `domains/[thing]/[thing].actions.ts`
 * via Vite's import.meta.glob (lazy by default — no modules are loaded until
 * a table calls ensureActions()).
 *
 * Call once at app boot (CustomerAppShell). Adding a new domain folder
 * auto-registers it — zero manual wiring.
 */
export function registerAllDomains(): void {
  for (const path of Object.keys(domainModules)) {
    const domain = path.split('/')[1];
    ActionRegistry.registerDomainLoader(domain, domainModules[path]);
  }
}
